import { CsvFileTrainingVariables } from './CsvFileDataset';
import DataSetRecord from './DataSetRecord';
import DataSetType from './DataSetType';
import { FromRedshiftTablesTrainingVariables } from './FromRedshiftTables';
import { LtbDatasetVariables } from './ltb/LtbDataset';
import { MkAudienceTrainingVariables } from './mk_audience/MkAudienceDataset';

export type TrainingDatasetVariables =
  | LtbDatasetVariables
  | MkAudienceTrainingVariables
  | FromRedshiftTablesTrainingVariables
  | CsvFileTrainingVariables;

/**
 * A model's training parameters, keyed by the connector it was built from.
 *
 * Declared `{ ltb }` only, for years, while `getModelTrainingParams` has always
 * read `model.training[connector]` for any `ModelBuildType`. So every
 * customer-fit model has real parameters sitting under `mk_audience` that the
 * type said could not exist, and anything wanting the audience a fit model
 * trained on had to cast to reach them.
 *
 * `ltb` keeps its precise type because `back/signals/ltb` reads fields only it
 * has; the rest are typed as the union, which is what the connector-indexed
 * read returns anyway.
 */
export type AllTrainingDatasetVariables = {
  ltb?: LtbDatasetVariables;
  mk_audience?: MkAudienceTrainingVariables;
  csv_file?: CsvFileTrainingVariables;
  from_redshift_tables?: FromRedshiftTablesTrainingVariables;
  hubspot?: TrainingDatasetVariables;
  salesforce?: TrainingDatasetVariables;
  marketo?: TrainingDatasetVariables;
};

type DataSetContent = {
  redshiftQuery?: string;
  postgresQuery?: string;
  records?: DataSetRecord[];
};
export default class DataSet {
  type: DataSetType;

  name: string;

  size: number;

  content: DataSetContent;

  constructor(
    type: DataSetType,
    name: string,
    size: number,
    content: DataSetContent
  ) {
    this.type = type;
    this.name = name;
    this.size = size;
    this.content = content;
  }
}
